import { useState } from "react";
import Styles from "Styles/Styles.module.css";
import { input } from "./types";
import { SendNotifications } from "Services/Requests";
import { showErrorAlert, showWarningAlert, Toast } from "Util/Alerts";
import FormControl from "Components/FormControl";
import { useForm, SubmitHandler } from "react-hook-form";
import { Spin } from "antd";
import { IoIosWarning } from "react-icons/io";

function Notifications() {
    const [ErrorMsg, setErrorMsg] = useState<null | string>(null);
    const [loading, setLoading] = useState(false);

    const {
        register,
        handleSubmit,
        formState: { errors },
        reset,
    } = useForm<input>();

    const onSubmit: SubmitHandler<input> = async (data) => {
        try {
            setLoading(true);
            let response;
            response = await SendNotifications(data);

            if (response?.data?.status === 1) {
                Toast(response?.data?.message, "success");
                reset();
            } else {
                showWarningAlert(response?.data?.Message);
            }
        } catch (err: any) {
            showErrorAlert(
                err?.response?.data?.Message ||
                    err?.response?.data?.message ||
                    "Something went wrong, try again later"
            );
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className={Styles["Add_form_wrapper"]}>
            <h3>
                <span style={{ textTransform: "capitalize" }}>
                    Bulk Notification
                </span>{" "}
            </h3>
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={Styles["form"]}>
                    <FormControl
                        key={"Title"}
                        label={"Title"}
                        name={"title"}
                        register={register}
                        errors={errors["title"]}
                        requiredMessage={"This field is required"}
                        type={"text"}
                    />
                    <FormControl
                        key={"Message"}
                        label={"Message"}
                        name={"message"}
                        register={register}
                        errors={errors["message"]}
                        requiredMessage={"This field is required"}
                        type={"textarea"}
                    />
                    {ErrorMsg && (
                        <p className={Styles["Gen-erro_msg"]}>
                            <IoIosWarning /> {ErrorMsg}
                        </p>
                    )}
                </div>
                {loading ? (
                    <Spin size="default" />
                ) : (
                    <button> Send Notification</button>
                )}
            </form>
        </div>
    );
}

export default Notifications;
